import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "element"
  ]

  switch(e) {
    this._switchByElementType(e.currentTarget)
  }

  switchElements(v) {
    this.elementTargets.forEach(el => {
      if(el.dataset.switchValue === v) {
        el.style.display = "";
        return;
      }
      el.style.display = "none";
    })
  }

  connect() {
    const defaultSwitchValue = this.element.dataset.defaultSwitchValue;
    if (defaultSwitchValue.charAt(0) === "#") {
      const ele = this.element.querySelector(defaultSwitchValue);
      this._switchByElementType(ele)
    } else {
      this.switchElements(defaultSwitchValue);
    }
  }

  _switchByElementType(ele) {
    const v = ele.type === "checkbox" ? ele.checked.toString() : ele.value;
    this.switchElements(v)
  }
}
